import axios from "axios";

// Runtime config (do public/config.js) tem prioridade sobre o env de build.
// Isso permite mudar a URL do backend no Hostinger sem rebuildar o React.
const RUNTIME_URL =
  typeof window !== "undefined" && window.__PAINELBOT_CONFIG__?.BACKEND_URL;
const BACKEND_URL = RUNTIME_URL || process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
